import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, Award } from "lucide-react";
import { COMPANY, IMAGES } from "@/data/siteData";

const fade = (d) => ({ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.8, delay: d, ease: [0.22, 1, 0.36, 1] } });

export const Hero = () => (
  <section data-testid="home-hero" className="relative min-h-[88vh] overflow-hidden bg-foreground">
    <img src={IMAGES.hero} alt="Modern homes with rooftop solar panels" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-foreground/55" />
    <div className="absolute inset-0 bg-gradient-to-r from-foreground/70 via-foreground/30 to-transparent" />

    <div className="relative mx-auto flex min-h-[88vh] max-w-7xl flex-col justify-end px-6 pb-24 pt-32 lg:px-10">
      <motion.p {...fade(0)} className="eyebrow text-accent">Ohio &amp; Northern Kentucky &middot; Est. 2024</motion.p>
      <motion.h1 {...fade(0.1)} className="mt-6 max-w-3xl font-display text-4xl font-light leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
        {COMPANY.tagline}
      </motion.h1>
      <motion.p {...fade(0.2)} className="mt-6 max-w-xl text-base font-light leading-relaxed text-white/80 md:text-lg">
        Independent solar operations &amp; maintenance for homeowners and solar businesses across Ohio and Northern
        Kentucky. Certified, NABCEP licensed, and still here when the original installer isn&rsquo;t.
      </motion.p>
      <motion.div {...fade(0.3)} className="mt-10 flex flex-wrap items-center gap-4">
        <Link
          to="/contact"
          data-testid="hero-contact-cta"
          className="inline-flex items-center gap-2 rounded-full bg-accent px-7 py-3.5 text-sm font-medium text-foreground transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-lg"
        >
          Request Service <ArrowRight className="h-4 w-4" />
        </Link>
        <Link
          to="/services"
          data-testid="hero-services-cta"
          className="inline-flex items-center gap-2 rounded-full border border-white/40 px-7 py-3.5 text-sm font-medium text-white transition-[background-color,border-color] duration-200 hover:border-white hover:bg-white/10"
        >
          Explore Services
        </Link>
      </motion.div>
      <motion.div {...fade(0.45)} className="mt-14 flex flex-wrap gap-8 border-t border-white/15 pt-8 text-sm text-white/80">
        <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-accent" strokeWidth={1.75} /> BBB Accredited &middot; A Rating</span>
        <span className="flex items-center gap-2"><Award className="h-4 w-4 text-accent" strokeWidth={1.75} /> NABCEP Licensed</span>
      </motion.div>
    </div>
  </section>
);
